import React from 'react';
import { css } from '@emotion/css';

import { useTranslation } from '@lyearn/i18n';
import { cn } from '@lyearn/style';
import { Button, Stack, Typography } from '@lyearn/ui';
import { Link } from '@/components/Link';

const bold_css = css`
  font-weight: 500;
`;

const DoesNotExist: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Stack
      alignItems="center"
      className="relative h-full flex-1 xs:px-24"
      direction="col"
      justifyContent="center">
      <Typography className="xs:heading-xl text-center" variant="display-xxxl">
        {t('Common:Error.WeLookedEverywhere')}
      </Typography>
      <Typography className="mb-48 mt-20 text-center" variant="body-long-01">
        {t('Common:Error.Error404Description')}
      </Typography>
      <Link to="/">
        <Button>{t('Common:Actions.BackToHome')}</Button>
      </Link>
      <Stack alignItems="center" className="absolute bottom-48 w-full" justifyContent="center">
        <Typography color="text-text-secondary" variant="body-short-01">
          {t('Common:Error.ErrorCode')}
        </Typography>
        <Typography className={cn('ms-4', bold_css)} variant="body-short-01">
          {t('Common:Error.404')}
        </Typography>
      </Stack>
    </Stack>
  );
};

export default React.memo(DoesNotExist);
